import React from 'react';
import './FoundersSection.css';

export default function FoundersSection() {
  return (
    <section id="m-founders" className="m-founders" aria-labelledby="m-founders-title">
      <div className="m-founders__card">
        {/* Boston College Crest */}
        <div className="m-founders__crest-wrap">
          <img 
            src="/other_images/bc.png" 
            alt="Boston College" 
            className="m-founders__crest"
          />
        </div>

        {/* Content */}
        <div className="m-founders__content">
          <h2 id="m-founders-title" className="m-founders__title">
            Built by Students, for Students
          </h2>
          
          <p className="m-founders__text">
            We didn't build DocuHounds sitting in some quiet library with nothing else going on. We built it while juggling classes, work, deadlines, and everything else life throws at you.
          </p>

          <p className="m-founders__text">
            Most tools assume you have time to plan everything perfectly. They assume you can sit down for hours, stay organized, and keep track of every little change across your classes. That's not reality.
          </p>

          <p className="m-founders__text">
            We built DocuHounds for students who are working shifts, commuting to campus, catching up late at night, and still trying to stay on top of everything.
          </p>

          <p className="m-founders__text">
            Upload your syllabus and your whole semester gets organized. Your assignments, deadlines, and materials all live in one place. Your study tools come from your actual coursework, not generic content.
          </p>

          <p className="m-founders__text">
            No spreadsheets. No bouncing between five apps. No guessing what matters most today. Just a system that keeps you on track even when your schedule isn't perfect.
          </p>

          <p className="m-founders__tagline">
            We built the tool we wish we had when everything felt scattered. Now it's yours.
          </p>
        </div>
      </div>
    </section>
  );
}
